import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type Store from '@ember-data/store'
import type SchoolClass from 'teacher-ui-client/models/school-class'
import type School from 'teacher-ui-client/models/school'

/**
 * This route is responsible for loading the necessary school/teacher/student/schoolclass records from gravity for use
 * in the reporting area.
 */
export default class extends Route {
  @service session!: SessionService

  @service store!: Store

  async model() {
    const { id: schoolId } = this.session.currentSchool

    await Promise.all([
      // Load gravity v3 data into ember-data. Pages can then use store.peek functions to obtain the data they need.
      this.store.query<SchoolClass>('school-class', {
        // @ts-expect-error - include types not correct
        include: 'teachers,students',
      }),
      // ensure school.teachers relationship is loaded
      // Reload ensures it doesnt return immediately with only current items from store
      this.store.findRecord<School>('school', schoolId, {
        // @ts-expect-error - include types not correct
        include: 'teachers',
        reload: true,
      }),
    ])

    return
  }
}
